import { trackEvent } from 'lib/ui-analytics';
import { createUserInteraction } from '../utils';

import { TRACKING_ACTION, TRACKING_INTERACTION } from '../Constants';

export const utagSortClicked = (label) => {
	const interaction = createUserInteraction({
		eventType: TRACKING_ACTION.SORT_CHANGE,
		searchOption: TRACKING_INTERACTION.SORT_CHANGE.replace('{0}', label),
	});

	trackEvent(interaction);
};
